// extracted by mini-css-extract-plugin
export default {"rating":"OD-z","numberOfStars":"PD-z","count":"QD-z","barGraphSpacing":"RD-z","barGraph":"SD-z"};